__webpack_require__.p = "/ruminations/";